import { Link } from 'react-router-dom'

export default function ActivationPendingPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        {/* Logo */}
        <a href="/" className="flex justify-center items-center space-x-2 mb-8">
          <img src="/static/images/favicon.ico" alt="ReadLocker" className="w-10 h-10" />
          <span className="text-2xl font-bold text-gray-900">ReadLocker</span>
        </a>

        <div className="bg-white py-8 px-4 shadow-xl shadow-gray-200/50 sm:rounded-2xl sm:px-10 text-center">
          <div className="w-14 h-14 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
          </div>

          <h2 className="text-xl font-bold text-gray-900 mb-2">Check your email</h2>
          <p className="text-sm text-gray-500 mb-6">
            We sent an activation link to your email address. Click the link in the email to activate your account and start using ReadLocker.
          </p>

          <div className="bg-gray-50 rounded-xl p-4 mb-6 text-left">
            <p className="text-xs text-gray-500">
              <span className="font-medium text-gray-700">Didn't receive it?</span>{' '}
              Check your spam folder, or contact support if the problem persists.
            </p>
          </div>

          <Link
            to="/login"
            className="inline-block w-full py-3 px-4 rounded-xl text-sm font-medium text-white bg-primary hover:bg-secondary transition-colors text-center"
          >
            Back to Sign in
          </Link>
        </div>
      </div>
    </div>
  )
}

